
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class CenterInfo extends Vue {
  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("centerInfo");
  }

  get activeInstituteCount(): number {
    return this.rawChartData[0]?.activeInstituteCount || 0;
  }

  get deactiveInstituteCount(): number {
    return this.rawChartData[0]?.deactiveInstituteCount || 0;
  }

  get universityCount(): number {
    return this.rawChartData[0]?.universityCount || 0;
  }

  get clinicCount(): number {
    return this.rawChartData[0]?.clinicCount || 0;
  }

  get PractiseCount(): number {
    return this.rawChartData[0]?.PractiseCount || 0;
  }


  async mounted() {
    try {
      await dataVisualizationModule.loadAll("centerInfo");
    } catch (error) {
      console.error("Failed to load data", error);
    }
  }
}
